import { render } from "./ItemByCategory.vue?vue&type=template&id=3755080a&scoped=true&ts=true"
import script from "./ItemByCategory.vue?vue&type=script&lang=ts"
export * from "./ItemByCategory.vue?vue&type=script&lang=ts"

import "./ItemByCategory.vue?vue&type=style&index=0&id=3755080a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3755080a"]])

export default __exports__